<template>
  <v-footer
    app
    class="colorText--text text--darken-1 colorText lighten-1"
    style="z-index:4"
  >
    <span class="font-weight-medium">&copy; 2021</span>
    <v-spacer></v-spacer>
    <span>{{ $t('version', { version }) }}</span>
  </v-footer>
</template>

<script>
import { getVersion } from '../constant'
export default {
  computed: {
    version() {
      return getVersion()
    },
  },
}
</script>

<style></style>
